import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import './loader.css';

export function Loader() {
	return <AiOutlineLoading3Quarters icon="icon-park-outline:loading-one" className="loader-icon " />
}